import TimImg from '#/team/Tim_202111_resized.jpg'
import ViktorImg from '#/team/Viktor_202111_resized.jpg'
import ParImg from '#/team/Par_202111_resized.jpg'
import DavidImg from '#/team/David_202404_resized.jpg'
import DanialImg from '#/team/Danial_202509_resized.jpg'
import { useTranslation } from 'react-i18next'

export interface Person {
	img: string
	fullName: string
	positionTitle: string
	description: string
	mail: string
	phone?: string
	linkedin?: string
}

export type SalesPerson = Omit<
	Person,
	'fullName' | 'phone' | 'mail' | 'linkedin'
> & {
	tags: string[]
}

export const SALES_TEAM: { [name: string]: SalesPerson } = {
	'Tim Hodell': {
		img: TimImg,
		positionTitle: 'Grundare &  CCO',
		tags: ['30+ arbetsplatser', 'CBD-expert'],
		description:
			'Tim är grundare och ansvarig för våra relationer med allt utbud. Han är också känd för att hjälpa stora techbolag att hitta nya hem.',
	},
	'Viktor Söderström Hahn': {
		img: ViktorImg,
		positionTitle: 'Grundare & CEO',
		tags: ['50+ arbetsplatser', 'CBD-expert'],
		description:
			'En av grundarna och vår kära VD med erfarenhet av större och mer komplicerade flyttar',
	},
	'Pär Lövgren': {
		img: ParImg,
		positionTitle: 'Kontorsexpert',
		tags: ['coworking', 'Lyssnare'],
		description:
			'Pär förstår våra kunders behov samt utmaningar. Han kan ge exempel på hur vi hjälpt andra bolag med samma behov och har alltid en bra lösning i rockärmen.',
	},
	'David Kostadinovic': {
		img: DavidImg,
		positionTitle: 'Kontorsexpert',
		tags: ['kontorshotell', 'snabb'],
		description:
			'David jobbar över alla marknader och kan allt mellan himmel och jord om de hundratals kontorshotell som finns i Sverige.',
	},
	'Danial Brännmark Hassan': {
		img: DanialImg,
		positionTitle: 'Kontorsexpert',
		tags: ['Kontorshotell', 'Coworking'],
		description:
			'Med flera års erfarenhet från coworkingvärlden, där Danial arbetat som uthyrare och hjälpt otaliga företag att hitta flexibla kontorslösningar, har han byggt upp en unik förståelse för både hyresgästers och hyresvärdars behov.',
	},
}

const SALES_TEAM_NAMES = Object.keys(SALES_TEAM)

export function useManagerInfoForHomepage(): Array<
	SalesPerson & { fullName: string }
> {
	const { t } = useTranslation()
	return SALES_TEAM_NAMES.map((name) => {
		return {
			...SALES_TEAM[name]!,
			fullName: name,
			positionTitle: t(SALES_TEAM[name]?.positionTitle || ''),
			tags: SALES_TEAM[name]?.tags.map((tag) => t(tag)) || [],
			description: t(SALES_TEAM[name]?.description || ''),
		}
	})
}

export function getPersonOfTheDay(): { img: string; name: string } {
	const date = new Date().getDate()
	const name = SALES_TEAM_NAMES[date % SALES_TEAM_NAMES.length]!
	return { img: SALES_TEAM[name]!.img, name: name.replace(/ .*/, '') }
}

export function getTeamMemberName(memberInfo: SalesPerson): string | undefined {
	for (const name in SALES_TEAM) {
		if (Object.prototype.hasOwnProperty.call(SALES_TEAM, name)) {
			if (SALES_TEAM[name] === memberInfo) {
				return name
			}
		}
	}
	return undefined // Return undefined if the member is not found
}
